import axios from "axios";

// Prayer Cheer (함께 축원/합장 실시간 DB 연동 API)
// Django 백엔드 (AWS RDS MySQL prayer_cheer 테이블 연동)
const BACKEND_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.binaida.net/api/"
    : "http://localhost:8000/api/";

export const prayerCheerAPI = {
  // DB에서 사찰별 또는 전체 촛불 축원 카운트 실시간 조회
  getCounts: async (templeId) => {
    const url = templeId
      ? `${BACKEND_BASE_URL}order/cheer/?temple_id=${templeId}`
      : `${BACKEND_BASE_URL}order/cheer/`;
    try {
      const res = await axios.get(url, { timeout: 3500 });
      return res.data?.results || {};
    } catch (e) {
      console.warn("DB 축원 카운트 조회 fallback:", e.message);
      return {};
    }
  },

  // DB에 축원(합장) +1 증가 실시간 저장
  addCheer: async (candleId, templeId = "") => {
    try {
      const res = await axios.post(
        `${BACKEND_BASE_URL}order/cheer/`,
        { candle_id: candleId, temple_id: templeId },
        { timeout: 3500 }
      );
      return res.data;
    } catch (e) {
      console.warn("DB 축원 카운트 저장 fallback:", e.message);
      return null;
    }
  },
};

